import React from 'react';

import { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';

import { ExecutionStatusLozenge } from '@qality/common-components/src/atoms/ExecutionStatusLozenge';
import { ExecutionStatus } from '@qality/common-model';
import { StatusesGroup } from '@qality/common-utils';

type ExecutionStatusSelectOptionsProps = {
  statusesCategories: StatusesGroup;
  onClick: (value: ExecutionStatus) => void;
};

export function ExecutionStatusSelectOptions({
  statusesCategories,
  onClick,
}: ExecutionStatusSelectOptionsProps) {
  const totalLength = statusesCategories.reduce(
    (acc, status) => acc + status.options.length,
    0
  );

  return (
    <>
      {statusesCategories
        .filter((group) => group.options.length > 0)
        .map((statusesCategory) => (
          <DropdownItemGroup
            title={statusesCategory.label}
            key={statusesCategory.label}
          >
            {statusesCategory.options.map((status) => (
              <DropdownItem
                key={status.name}
                onClick={() => {
                  onClick(status);
                }}
              >
                <ExecutionStatusLozenge status={status} />
              </DropdownItem>
            ))}
          </DropdownItemGroup>
        ))}
      {totalLength <= 0 && <p>No data found.</p>}
    </>
  );
}
